
import Vue from "vue";

export default Vue.extend({
  computed: {
    routeName() {
      return this.$route.name as string;
    },
  },
});
